import { isValid } from 'date-fns/isValid';
import { parseISO } from 'date-fns/parseISO';

export const coerceDate = (input: Date | string | number): Date => {
	if (input instanceof Date) return input;

	if (typeof input === 'number') return new Date(input);

	if (typeof input === 'string') {
		const iso = parseISO(input);
		return isValid(iso) ? iso : new Date(input);
	}

	return new Date(NaN);
};
